import type {TokenClaimsSerializer} from "@/generated/DjangoTypes";
import useTokenStore from "@/store/token";
import {fetchCompany} from "@/utils/loaderUtils";
import {createFileRoute, redirect, type ParsedLocation} from "@tanstack/react-router";
import {jwtDecode} from "jwt-decode";

export const Route = createFileRoute("/_authenticated/_company")({
  beforeLoad: async ({location, params}: {location: ParsedLocation; params: {companyId?: number}}) => {
    const token = useTokenStore.getState().access;

    if (!token) {
      throw redirect({to: "/login", replace: true});
    }

    const claims = jwtDecode<TokenClaimsSerializer>(token);
    const isAdmin = claims.access_level === "COMPANY_ADMIN" || claims.access_level === "INFLUENCER_ADMIN";
    const isAgency = claims.access_level === "AGENCY";
    const isCompany = claims.access_level === "SINGLE_BRAND" || claims.access_level === "SUB_BRAND";

    if (isAdmin || isCompany) {
      return;
    }

    const companyId = Number(params.companyId);
    const company = isAgency && companyId ? await fetchCompany(companyId).catch(() => null) : null;
    const agencyId = company?.agency?.id ?? claims.agency_ids?.[0]!;
    const companyPath = `/company/${companyId}`;

    if (!company?.agency) {
      throw redirect({to: "/agency/$agencyId/dashboard", params: {agencyId}, replace: true});
    }

    if (!location.pathname.startsWith(companyPath)) {
      return;
    }

    const href = location.pathname.startsWith(`${companyPath}/chat`)
      ? location.href.replace(`${companyPath}/chat`, `/agency/${agencyId}/chat/${companyId}`)
      : location.href.replace(companyPath, `/agency/${agencyId}/subbrand/${companyId}`);

    throw redirect({href, replace: true});
  },
});
